import React, { ReactNode } from 'react';
import { Header } from '../header';
import './layout.css';

interface LayoutProps {
  children: ReactNode;
  isConnected: boolean;
  userAddress: string;
  chainId: number | null;
  onConnect: () => void;
  onDisconnect: () => void;
}

export const Layout: React.FC<LayoutProps> = ({
  children,
  isConnected,
  userAddress,
  chainId,
  onConnect,
  onDisconnect,
}) => (
  <div
    className="app-container"
    style={{
      backgroundImage: `url(${process.env.PUBLIC_URL || ''}/bg.webp)`,
    }}
  >
    <Header
      isConnected={isConnected}
      userAddress={userAddress}
      onConnect={onConnect}
      onDisconnect={onDisconnect}
    />
    <main className="main-content">{children}</main>
    <footer className="app-footer">
      <p>Chain ID: {chainId ?? 'Not connected'}</p>
      <p>Make sure you&apos;re on the correct network</p>
    </footer>
  </div>
);
